
import { connect } from "react-redux";
// 订单详情
import CustomOrderList from "../components/CustomOrderList";


const mapState = state => ({
  masterList: state.customOrderList.masterList,
  queryResult: state.customOrderList.queryResult,
  page: state.customOrderList.page,
  statistics: state.customOrderList.statistics,

});


const mapDispatch = dispatch => {
  const col = dispatch.customOrderList;
  const oi = dispatch.customOrder;
  return {
    getCustomMasterList: col.getCustomMasterList,
    customOrderListSearchFormQuery: col.customOrderListSearchFormQuery,
    onShowSizeChange: col.onShowSizeChange,
    onChange: col.onChange,
    delRow: col.delRow,
    editRow: oi.editRow,
    exportCustomOrderList: col.exportCustomOrderList,
    resetQueryParamsAndQuery: col.resetQueryParamsAndQuery,
    updateExportProcess: dispatch.globalStatus.updateExportProcess
  }
};

export default connect(
  mapState,
  mapDispatch
)(CustomOrderList);
